import { render, staticRenderFns } from "./SelectRecipients.vue?vue&type=template&id=c18c5f14&"
import script from "./SelectRecipients.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SelectRecipients.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports